const _ = require("lodash");

export async function getMediaBaseNotifications({groupId, modelId}) {
    const  users = await global.app[modelId].User.find({
        group: new global.ObjectID(groupId),
        fieldPath: ['id'],
        query: {}
    })
    const media = await global.app[modelId].MediaBase.find({
        group: new global.ObjectID(groupId),
        fieldPath: ['id', 'orangeStyledRow'],
        query: {}
    })

    return users.reduce((acc, user) => ({
        [user.id]: {
            [`m-${modelId}-mediaBaseAdmin`]: media.filter(mediaElement => !!mediaElement.orangeStyledRow).length
        },
        ...acc
    }), {})

}

export async function getTicketNotificationData({userId, groupId, modelId}) {

    const ticketSubjects = await global.app[modelId].TicketSubject.find({
        group: new global.ObjectID(groupId),
        fieldPath: ['id', 'users.id'],
        query: {}
    })

    const adminIds = ticketSubjects.flatMap(o => o.users.map(u => u.id))

    const adminIdsByTicketSubject = ticketSubjects.reduce((acc, ticketSubject) => ({
        ...acc,
        [ticketSubject.id]: ticketSubject.users.map(u => u.id)
    }), {})

    const tickets = await global.app[modelId].Ticket.find({
        query: {ticketStatus: 'inProgress'},
        fieldPath: ['id', 'name', 'user.id', 'conversations.sender.id', 'ticketSubject.id'],
        group: new global.ObjectID(groupId)
    })


    const userTickets = tickets.filter(ticket => {
        const lastComment = _.last(_.orderBy(ticket.conversations, 'timestamp'))
        return ticket.user && ticket.user.id !== _.get(lastComment, 'sender.id')
    })

    const ticketGroupedByUser =  _.groupBy(userTickets, 'user.id')


    const lengthTicketGroupedByUser =  Object.keys(ticketGroupedByUser).reduce((acc, userId) => ({
        [userId]: ticketGroupedByUser[userId].length,
        ...acc
    }), {})


    const adminTickets = tickets.filter(ticket => {
        const lastComment = _.last(_.orderBy(ticket.conversations, 'timestamp'))
        return ticket.user && ticket.user.id === _.get(lastComment, 'sender.id') && ticket.user.id !== userId
    })

    const lengthTicketGroupedByAdmin =  adminIds.reduce((acc, adminId) => {
        const filteredTicket = adminTickets.filter(
            adminTicket => adminIdsByTicketSubject[adminTicket.ticketSubject.id] && adminIdsByTicketSubject[adminTicket.ticketSubject.id].includes(adminId)
        )
        return filteredTicket.length
            ? {
                [adminId]: filteredTicket.length,
                ...acc
            }
            : acc
    }, {})

    const allUser = {...lengthTicketGroupedByUser, ...lengthTicketGroupedByAdmin}

    return Object.keys(allUser).reduce((acc, userId) => ({
        [userId]: {
            [`m-${modelId}-tickets`]: allUser[userId]
        },
        ...acc
    }), {})
}
